<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
 <vx-card title="Data">
   <h3>{{instructorModel.Name}}</h3>
   <h3>In System from {{instructorModel.CreatedDate}}</h3>
   </vx-card>
   <!-- old Courses -->
     <vx-card title="Courses " style="margin-top:20px">
    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="instructorCourseClasses">

      <template slot="thead">
        <vs-th sort-key="Name">{{$t('Name')}}</vs-th>
         <vs-th sort-key="Name">{{$t('Start')}}</vs-th>
          <vs-th sort-key="Name">{{$t('End')}}</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>

            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
       <!-- mainData -->
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Course.Name }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.StartDate }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.EndDate }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
         </vx-card>
   <!-- old Exams -->
  <vx-card :title="$t('Exams') " style="margin-top:20px">
    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="instructorExams">

      <template slot="thead">
        <vs-th sort-key="Name">{{$t('Code')}}</vs-th>
         <vs-th sort-key="Name">{{$t('ExamType')}}</vs-th>
          <vs-th sort-key="Name">{{$t('Course')}}</vs-th>
          <vs-th sort-key="Name">{{$t('PercMark')}}</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>

            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
       <!-- mainData -->
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Code }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.ExamType.Name }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Course.Name }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.PercentageOfTraineePass }} %</p>
              </vs-td>
              
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
         </vx-card>
  <!-- old Assessment -->
  <vx-card title="Assessment " style="margin-top:20px">
    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="instructorAssessments">

      <template slot="thead">
        <vs-th sort-key="Name">{{$t('ReviewCode')}}</vs-th>
         <vs-th sort-key="Name">{{$t('Title')}}</vs-th>
         <vs-th sort-key="Name">{{$t('Course')}}</vs-th>
         <vs-th sort-key="Name">{{$t('QuestionText')}}</vs-th>
         <vs-th sort-key="Name">{{$t('AnswerText')}}</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>

            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
       <!-- mainData -->
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.CustomerReview.Code }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.CustomerReview.Title }}</p>
              </vs-td>
                <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Course.Name }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.CustomerReviewQuestion.QuestionText }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.CustomerReviewAnswer.AnswerText }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
   </vx-card>

   <!-- Rate (for customer review) -->

    <vx-card title="Review" style="margin-top:20px">
      <div class="vx-row flex-1"  >

     
        <div class="flex-1" style="margin-left:10px">
        <vs-select autocomplete class="mt-5 w-full"  :label="$t('CourseClass')" v-model="ReviewModel.CourseClassID"  >
           <vs-select-item :key="index" :value="item.ID" :text="item.ClassNo" v-for="(item,index) in instructorCourseClasses" v-show="index<3" />
        </vs-select>
        <span class="text-danger text-sm"  v-show="errors.has('Course-Class')">{{ errors.first('Course-Class') }}</span>
      </div>
      <div class="flex-1" style="margin-left:10px">
        <!-- start date -->
        <div class="spacer"></div>
        <label for="startDate" class="vs-input--label">{{$t('From')}}</label>
        <datepicker :format="format" :placeholder="$t('StartDate')" v-model="ReviewModel.DateFrom"   input-class="mt-5 w-full" name="startDate" ></datepicker>        
          </div>
       <div class="flex-1" style="margin-left:10px">
        <!-- End date -->
         <div class="spacer" style="margin-left:10px"></div>
        <label for="startDate" class="vs-input--label">{{$t('To')}}</label>
        <datepicker :format="format" :placeholder="$t('EndDate')" v-model="ReviewModel.DateTo"   class="mt-5 w-full" name="endDate" ></datepicker>    
  </div>
    <div class="flex-1">
        <vs-button type="border" class="mb-4 mt-10" icon-pack="feather" @click="Show_question" :disabled="!ReviewModel.CourseClassID" style="margin-left:10px"> {{$t('Show')}} </vs-button>
        </div>
        </div>
       <div class="mb-5" style="margin-top:20px">
             <div :data="qr" :key="indexqr" v-for="(qr, indexqr) in questionResult">
                      <vs-button class="w-full" disabled  type="border">{{indexqr+1}}-{{ qr.QuestionText }}</vs-button>
                      <div v-if="qr.QuestionTypeID==1">
                        <div :key="indextr" v-for="(ar, indextr) in qr.AssessmentResults">
                              <p class="product-name font-medium truncate ml-5" v-if="ar.AnswerText">--{{ ar.AnswerText }}</p>
                        </div>
                    </div>

                    <div v-if="qr.QuestionTypeID==2">  <!-- answer is true and false  --> 
                        <p class="product-name font-medium truncate ml-5" >--true  {{(qr.Count*100)/numberOfTrainee}}%</p>
                        <p class="product-name font-medium truncate ml-5" >--false  {{((numberOfTrainee-qr.Count)*100)/numberOfTrainee}}%</p>

                    </div>

                    <div v-if="qr.QuestionTypeID==4|| qr.QuestionTypeID==3">  <!--  multiple chooice  --> 
                        <div :key="indextr" v-for="(ar, indextr) in qr.CustomerReviewAnswers">
                              <p class="product-name font-medium truncate ml-5" v-if="ar.AnswerText">{{ ar.AnswerText }}  {{(ar.Count*100)/numberOfTrainee}}%</p>
                        </div>
                    </div>

             </div>
         </div>
   </vx-card>
 <vs-button class="ml-4 mt-2" type="border"  color="danger" @click="cancle">{{$t('Cancel')}}</vs-button>
  </div>
</template>

<script>

import moduleInstructor from "@/store/instructor/moduleInstructor.js";
import moduleCourseReview from "@/store/customerReview/courseReview/moduleCourseReview.js";
import moduleQuestionType from "@/store/settings/questionType/moduleQuestionType.js";
import Datepicker from 'vuejs-datepicker';
export default {
  components: {
     Datepicker
  },
  data() {
    return {
      selected: [],
     instructorModel:{},
     instructorCourseClasses:[],
     instructorExams:[],
     instructorAssessments:[],
      itemsPerPage: 3,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      rowDataForDelete: {},
      activeConfirm: false,
       numberOfTrainee:0,
       ReviewModel:{},
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    questionResult(){
      debugger;
      return this.$store.state.CourseReviewList.QuestionsByFilter;
    },
    
    questionTypes() {
      return this.$store.state.questionTypeList.questionTypes;
    },
  },

  methods: {
     cancle(){
       this.$store.state.CourseReviewList.QuestionsByFilter = [];
      this.$router.push('/Instructor'); 
    },
     Show_question(){
       debugger
       this.ReviewModel.CategoryAssessmentID=4;
       this.ReviewModel.IsInstructorHistory=true;
      debugger; 
        this.getNumberOfTrainee();
      this.$store.dispatch("CourseReviewList/getQuestionWithResultAnswerByFilter",this.ReviewModel);
    },
      getNumberOfTrainee(){
      debugger;
      this.$store.dispatch("CourseReviewList/getNumberOfTrainee",this.ReviewModel).then(res=>{
              console.log(res);
                 this.numberOfTrainee=res.data;
            }).catch(err => {
              console.error(err);
            });
    },
  },

  created() {
    if (!moduleQuestionType.isRegistered) {
      this.$store.registerModule("questionTypeList", moduleQuestionType);
      moduleQuestionType.isRegistered = true;
    }
       this.$store.dispatch("questionTypeList/fetchDataListItems");
    if (!moduleCourseReview.isRegistered) {
      this.$store.registerModule("CourseReviewList", moduleCourseReview);
      moduleCourseReview.isRegistered = true;
    }
    debugger;
    if (!moduleInstructor.isRegistered) {
      this.$store.registerModule("instructorList", moduleInstructor);
      moduleInstructor.isRegistered = true;
    }
      const ID = this.$route.params.ID
     if(ID!=undefined)
     {

      this.$store.dispatch("instructorList/GetItemByID", ID)
      .then(res => {
         this.instructorModel = res.data
      debugger;
       })
      .catch(err => {
         debugger;
        if(err.response.status === 404) {
          this.user_not_found = true
          return
        }
        console.error(err) })

         this.$store.dispatch("instructorList/GetAllInstructorCourses", ID).then(res => {
         this.instructorCourseClasses = res.data
      debugger;
       })

         this.$store.dispatch("instructorList/GetAllInstructorExams", ID).then(res => {
         this.instructorExams = res.data
      debugger;
       })


         this.$store.dispatch("instructorList/GetAllInstructorAssessment", ID).then(res => {
         this.instructorAssessments = res.data
      debugger;
       })


      //    this.$store.dispatch("instructorList/GetAllInstructorAssessment", ID).then(res => {
      //    this.instructorAssessments = res.data
      // debugger;
      //  })

     }
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
